var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        ((_obj = {
          "breadcrumb-gi": _vm.isGioielleriaItalianaB2B,
          "breadcrumb-ama": _vm.isAma
        }),
        (_obj["breadcrumb-plugin breadcrumb-plugin-" + _vm.theme] =
          !_vm.isAma && !_vm.isGioielleriaItalianaB2B),
        _obj)
    },
    [
      _vm.buildYourJewelMode
        ? _c("div", { staticClass: "breadcrumb-row" }, [
            _c(
              "span",
              {
                staticClass: "path",
                class: {
                  "border-top-gold":
                    _vm.isGioielleriaItalianaB2B &&
                    (_vm.productType == "JEWELLERY" ||
                      _vm.productType == "GOLDSMITH")
                }
              },
              [
                _vm.showHomeLink
                  ? _c(
                      "span",
                      {
                        staticClass: "cursor-pointer",
                        on: {
                          click: function($event) {
                            return _vm.goToHome()
                          }
                        }
                      },
                      [_vm._v("Home")]
                    )
                  : _vm._e()
              ]
            )
          ])
        : _vm._e(),
      _c("div", { staticClass: "breadcrumb-row" }, [
        _vm.productType && _vm.productType == "GOLDSMITH"
          ? _c("div", { staticClass: "go-to-btn" }, [
              _c(
                "span",
                {
                  staticClass: "cursor-pointer",
                  on: {
                    click: function($event) {
                      return _vm.navigateTo({ productType: "JEWELLERY" })
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("goToGio")))]
              )
            ])
          : _vm._e()
      ]),
      !_vm.buildYourJewelMode
        ? _c("div", { staticClass: "breadcrumb-row" }, [
            _c(
              "span",
              {
                staticClass: "path",
                class: {
                  "border-top-gold":
                    _vm.isGioielleriaItalianaB2B &&
                    (_vm.productType == "JEWELLERY" ||
                      _vm.productType == "GOLDSMITH")
                }
              },
              [
                _vm.showHomeLink
                  ? _c(
                      "span",
                      {
                        staticClass: "cursor-pointer",
                        on: {
                          click: function($event) {
                            return _vm.goToHome()
                          }
                        }
                      },
                      [_vm._v("Home")]
                    )
                  : _vm._e(),
                _vm.showProductType
                  ? _c(
                      "span",
                      {
                        staticClass: "cursor-pointer",
                        on: {
                          click: function($event) {
                            return _vm.navigateTo({
                              productType: _vm.productType
                            })
                          }
                        }
                      },
                      [
                        _vm.showHomeLink
                          ? _c("font-awesome-icon", {
                              staticClass: "angle-right",
                              attrs: { icon: ["fas", "angle-right"] }
                            })
                          : _vm._e(),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t(_vm.productType.toLowerCase())) +
                            " "
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showCategoryName
                  ? _c(
                      "span",
                      [
                        _c("font-awesome-icon", {
                          staticClass: "angle-right",
                          attrs: { icon: ["fas", "angle-right"] }
                        }),
                        _vm.currentCategoryDetail &&
                        _vm.currentCategoryDetail.name
                          ? _c(
                              "span",
                              {
                                staticClass: "cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.navigateTo({
                                      productType: _vm.productType,
                                      typeId: _vm.currentCategoryDetail.id
                                    })
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.currentCategoryDetail.name) +
                                    " "
                                )
                              ]
                            )
                          : _vm.currentProductCategoryDetail &&
                            _vm.currentProductCategoryDetail.name
                          ? _c(
                              "span",
                              {
                                staticClass: "cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.navigateTo({
                                      productType: _vm.productType,
                                      typeId:
                                        _vm.currentProductCategoryDetail.id
                                    })
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currentProductCategoryDetail.name
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm.currentCategory
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.currentCategory.name
                                      ? _vm.currentCategory.name
                                      : _vm.$t("allCategories")
                                  ) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.searchJewel.text
                  ? _c(
                      "span",
                      [
                        _c("font-awesome-icon", {
                          staticClass: "angle-right",
                          attrs: { icon: ["fas", "angle-right"] }
                        }),
                        _vm._v(' "' + _vm._s(_vm.searchJewel.text) + '" ')
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentJewelSelection && _vm.currentJewelSelection.name
                  ? _c(
                      "span",
                      [
                        _c("font-awesome-icon", {
                          staticClass: "angle-right",
                          attrs: { icon: ["fas", "angle-right"] }
                        }),
                        _vm._v(
                          " " + _vm._s(_vm.currentJewelSelection.name) + " "
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentProductSelection && _vm.currentProductSelection.name
                  ? _c(
                      "span",
                      [
                        _c("font-awesome-icon", {
                          staticClass: "angle-right",
                          attrs: { icon: ["fas", "angle-right"] }
                        }),
                        _vm._v(
                          " " + _vm._s(_vm.currentProductSelection.name) + " "
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }